import { ClientError } from "graphql-request";
import { useCallback, useState } from "react";

export type ConnectionState<Data> =
  | {
      __type: "connecting";
      connecting: true;
    }
  | {
      __type: "error";
      error: ClientError;
    }
  | {
      __type: "success";
      connecting: false;
      error: null;
      data: Data;
    }
  | {
      __type: "before_connecting";
      connecting: false;
    }
  | {
      __type: "ready";
      connecting: false;
    };

function useConnectState<TData>() {
  const [state, setState] = useState<ConnectionState<TData>>({
    __type: "before_connecting",
    connecting: false,
  });

  const setReady = useCallback(() => {
    setState({ __type: "ready", connecting: false });
  }, []);

  const setConnecting = useCallback(() => {
    setState({ __type: "connecting", connecting: true });
  }, []);

  const setError = useCallback((error: ClientError) => {
    setState({ __type: "error", error });
  }, []);

  const setData = useCallback((data: TData) => {
    setState({ __type: "success", connecting: false, error: null, data });
  }, []);

  return {
    state,
    setConnecting,
    setError,
    setData,
    setReady,
  };
}

export default useConnectState;
